import {
  Activity,
  Briefcase,
  CalendarCheck,
  CalendarDays,
  Code2,
  Cog,
  Coins,
  Compass,
  DollarSign,
  Factory,
  FileText,
  FlaskConical,
  Globe,
  GraduationCap,
  HardHat,
  Headphones,
  HelpCircle,
  Landmark,
  Layers,
  Leaf,
  LifeBuoy,
  type LucideIcon,
  Mail,
  MessageCircle,
  MessageSquare,
  Phone,
  PlayCircle,
  RefreshCw,
  Settings,
  Shield,
  Sparkles,
  Star,
  Store,
  Warehouse,
  Wrench,
  Zap,
} from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  activity: Activity,
  briefcase: Briefcase,
  'calendar-check': CalendarCheck,
  'calendar-days': CalendarDays,
  calendar: CalendarDays,
  'code-2': Code2,
  code: Code2,
  cog: Cog,
  coins: Coins,
  compass: Compass,
  'dollar-sign': DollarSign,
  factory: Factory,
  'file-text': FileText,
  'flask-conical': FlaskConical,
  flask: FlaskConical,
  globe: Globe,
  'graduation-cap': GraduationCap,
  'hard-hat': HardHat,
  construction: HardHat,
  headphones: Headphones,
  'help-circle': HelpCircle,
  landmark: Landmark,
  layers: Layers,
  leaf: Leaf,
  'life-buoy': LifeBuoy,
  mail: Mail,
  envelope: Mail,
  'message-circle': MessageCircle,
  'message-square': MessageSquare,
  phone: Phone,
  'play-circle': PlayCircle,
  play: PlayCircle,
  'refresh-cw': RefreshCw,
  settings: Settings,
  shield: Shield,
  sparkles: Sparkles,
  star: Star,
  store: Store,
  warehouse: Warehouse,
  wrench: Wrench,
  zap: Zap,
};

export function getNavIcon(keyword?: string | null): LucideIcon | null {
  if (!keyword) return null;
  return ICONS[keyword.trim().toLowerCase()] ?? null;
}
